import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Building2, Calendar, DollarSign } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface Box {
  location_status: string;
  storage_start_date?: string;
  stored_at?: string;
}

interface InStorageCardProps {
  box: Box;
}

export function InStorageCard({ box }: InStorageCardProps) {
  const storageDate = box.storage_start_date || box.stored_at;
  const storageDuration = storageDate 
    ? formatDistanceToNow(new Date(storageDate), { addSuffix: false })
    : "Unknown";

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center justify-between">
          <span className="flex items-center gap-2">
            <Building2 className="h-5 w-5" />
            Box in Storage
          </span>
          <Badge variant="secondary">Stored</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-start gap-3">
          <DollarSign className="h-4 w-4 mt-0.5 text-muted-foreground" />
          <div>
            <p className="text-sm font-medium">Monthly Storage Cost</p>
            <p className="text-sm text-muted-foreground">$9.99/month</p>
          </div>
        </div>

        {storageDate && (
          <div className="flex items-start gap-3">
            <Calendar className="h-4 w-4 mt-0.5 text-muted-foreground" />
            <div>
              <p className="text-sm font-medium">Storage Duration</p>
              <p className="text-sm text-muted-foreground">{storageDuration}</p>
            </div>
          </div>
        )}

        <div className="pt-3 border-t">
          <p className="text-xs text-muted-foreground">
            Your box is safely stored in our climate-controlled facility. Request a return anytime below.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
